import styled from '@emotion/styled';
import { useCallback, useEffect, useState } from 'react';
import { isEmpty } from 'lodash';
import { useRouter } from 'next/router';

import type { MainSite } from '../../../main/interfaces/MainSection.interface';
import type { EventBenefitResponse } from '../../../shared/interfaces';
import LoadingEvent from '../components/LoadingEvent';
import EventBenefit from '../../shared/components/EventBenefit';
import { PullToRefreshWrapper } from '../../../shared/components/PullToRefresh/m';
import { getBeautyBargain, getBeautyEvent, getEventBenefit } from '../../../shared/services/event-benefit.service';
import { amplitudeService } from '../../../shared/amplitude';
import { SelectBanner } from '../../../shared/amplitude/events';
import { isPC } from '../../../../util/window/getDevice';
import { PULL_TO_REFRESH_MAIN_TOP } from '../../../shared/constant/pull-to-refresh-margin-top';

const NotList = styled.div`
  width: ${isPC ? '1050px' : '100%'};
  margin: 0 auto 10px;
  padding: 168px 0;
  font-size: 16px;
  color: #b5b5b5;
  text-align: center;
`;

interface Props {
  mainSite: MainSite;
  eventType?: 'MARKET' | 'BEAUTY_BENEFIT' | 'BEAUTY_EVENT';
}

export default function EventBenefitContainer({ mainSite, eventType = 'MARKET' }: Props) {
  const router = useRouter();
  const [loading, setLoading] = useState<boolean>(true);
  const [eventList, setEventList] = useState<EventBenefitResponse[]>([]);

  const benefitList = useCallback(async () => {
    let bannerEvent: EventBenefitResponse[] = [];

    if (eventType === 'MARKET') {
      bannerEvent = await getEventBenefit();
    }
    if (eventType === 'BEAUTY_BENEFIT') {
      bannerEvent = await getBeautyBargain();
    }
    if (eventType === 'BEAUTY_EVENT') {
      bannerEvent = await getBeautyEvent();
    }

    setEventList(bannerEvent);
    setLoading(false);
  }, [eventType]);

  const handleClickBanner = (link: string | null, giftIds: string | null, index: number) => {
    amplitudeService.logEvent(
      new SelectBanner({
        eventName: eventType === 'BEAUTY_BENEFIT' ? 'select_benefit_list_banner' : 'select_brand_list_banner',
        url: link,
        contentId: giftIds,
        position: index + 1,
      }),
    );
  };

  useEffect(() => {
    void benefitList();
  }, [benefitList, router.isReady]);

  if (loading) {
    return <LoadingEvent />;
  }

  return (
    <PullToRefreshWrapper onRefresh={benefitList} marginTop={PULL_TO_REFRESH_MAIN_TOP}>
      {isEmpty(eventList) ? (
        <NotList>
          {eventType === 'MARKET' && '등록된 특가/혜택 이벤트가 없습니다.'}
          {eventType === 'BEAUTY_BENEFIT' && '등록된 특가 이벤트가 없습니다.'}
          {eventType === 'BEAUTY_EVENT' && '등록된 이벤트가 없습니다.'}
        </NotList>
      ) : (
        <EventBenefit site={mainSite} eventList={eventList} onClickBanner={handleClickBanner} />
      )}
    </PullToRefreshWrapper>
  );
}
